<template>
  <div class="border_parent">
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <i class="el-icon-location" style="color: #002d71; margin-right: 5px"></i>
        <el-breadcrumb-item :to="prePath">{{ prePageName }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ currentPageName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <b-card>
      <b-row type="flex" justify="center">
        <b-col>
          <div class="content">
            <div v-html="content"></div>
            <div v-if="currentPageType === 1" style="margin-bottom: 30px">
              <span style="float: right">{{ time }}</span>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { format } from "date-fns";
import request from "../utils/request";
export default {
  name: "Details",
  data() {
    return {
      requestUrl: {
        baseUrl: "/article",
        findByResearcherId: "/article/findByResearcherId",
        findByProjectId: "/article/findByProjectId",
        findByNewsId: "/article/findByNewsId",
        findByActivityId: "/article/findByActivityId",
      },
      relatedId: {
        articleId: "",
        researcherId: "",
        projectId: "",
      },
      content: "",
      time: "",
      currentPageType: -1,
      currentPageName: "",
      prePageName: "",
      prePath: {
        path: "",
      },
    };
  },
  created() {
    this.getRouterData();
    this.getData();
  },
  methods: {
    // 获取路由参数和当前模块名称
    getRouterData() {
      this.currentPageType = this.$route.query.type;
      if (this.currentPageType === "1") {
        this.relatedId.articleId = this.$route.query.articleId;
        this.prePageName = "公告";
        this.currentPageName = "公告详情";
        this.prePath.path = "/newsList";
      } else if (this.currentPageType === "3") {
        this.relatedId.researcherId = this.$route.query.researcherId;
        this.prePageName = "研究团队";
        this.currentPageName = "研究员详情";
        this.prePath.path = "/team";
      } else if (this.currentPageType === "4") {
        this.relatedId.projectId = this.$route.query.projectId;
        this.prePageName = "研究项目";
        this.currentPageName = "研究项目详情";
        this.prePath.path = "/project";
      } else if (this.currentPageType === "5") {
        this.relatedId.newsId = this.$route.query.newsId;
        this.prePageName = "团队动态";
        this.currentPageName = "动态详情";
        this.prePath.path = "/newsList";
      } else if (this.currentPageType === "6") {
        this.relatedId.activityId = this.$route.query.activityId;
        this.prePageName = "研究所活动";
        this.currentPageName = "研究所活动详情";
        this.prePath.path = "/activity";
      }
    },
    // 获取新闻数据
    getData() {
      if (this.relatedId.articleId) {
        request.get(this.requestUrl.baseUrl + "/" + this.relatedId.articleId).then((res) => {
          if (res.code === "200") {
            if (res.data) {
              this.content = res.data.content;
              this.time = format(new Date(res.data.time), "yyyy-MM-dd");
            }
          }
        });
      } else if (this.relatedId.researcherId) {
        request.get(this.requestUrl.findByResearcherId + "/" + this.relatedId.researcherId).then((res) => {
          if (res.code === "200") {
            if (res.data) {
              this.content = res.data.content;
            }
          }
        });
      } else if (this.relatedId.projectId) {
        request.get(this.requestUrl.findByProjectId + "/" + this.relatedId.projectId).then((res) => {
          if (res.code === "200") {
            if (res.data) {
              this.content = res.data.content;
            }
          }
        });
      } else if (this.relatedId.newsId) {
        request.get(this.requestUrl.findByNewsId + "/" + this.relatedId.newsId).then((res) => {
          if (res.code === "200") {
            if (res.data) {
              this.content = res.data.content;
            }
          }
        });
      } else if (this.relatedId.activityId) {
        request.get(this.requestUrl.findByActivityId + "/" + this.relatedId.activityId).then((res) => {
          if (res.code === "200") {
            if (res.data) {
              this.content = res.data.content;
            }
          }
        });
      }
      if (!this.content) {
        this.content = "暂无内容, 敬请期待。";
      }
    },
  },
};
</script>

<style scoped>
.border_parent {
  width: 80%;
  margin: auto;
}
.content {
  width: 90%;
  margin: 0 auto;
}
@media (max-width: 1000px) {
  .content /deep/ img {
    /* width: 50% !important; */
    margin: 0 auto;
    height: auto !important;
  }
}

@media (min-width: 1000px) and (max-width: 1205px) {
  .content /deep/ img {
    /* width: 30% !important; */
    margin: 0 auto;
    height: auto !important;
  }
}

@media (min-width: 1205px) {
  .content /deep/ img {
    /* width: 20% !important; */
    margin: 0 auto;
    height: auto !important;
  }
}

.icon {
  float: left;
  margin-right: 5px;
}
.breadcrumb {
  margin: 15px auto;
}

/* 修改面包屑伪类颜色 */
div/deep/.el-breadcrumb__inner:hover {
  color: #002d71;
}
</style>
